/**
 * @format
 */

import * as types from './actions';

const initialState = {
  /**
   * Holds portco's settings as key: value pairs
   * NOTE: In some cases, complex values are stored as values
   */
  portcoSettings: {},
  /**
   * Holds the loading status of each portco settting key
   */
  portcoSettingsLoading: {},
  /**
   * Holds the error status of each portco settting key
   */
  portcoSettingsError: {},
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    /**
     * Load portco setting by key reducers
     */
    case types.LOAD_PORTCO_SETTING_VALUE_BY_KEY_REQUEST:
    case types.UPDATE_PORTCO_SETTING_BY_KEY_REQUEST:
      return Object.assign({}, state, {
        portcoSettingsLoading: {
          ...state.portcoSettingsLoading,
          [payload.company_id]: {
            ...(state.portcoSettingsLoading &&
              state.portcoSettingsLoading[payload.company_id]),
            [payload.key]: true,
          },
        },
        portcoSettingsError: {
          ...state.portcoSettingsError,
          [payload.company_id]: {
            ...(state.portcoSettingsError &&
              state.portcoSettingsError[payload.company_id]),
            [payload.key]: null,
          },
        },
      });
    case types.LOAD_PORTCO_SETTING_VALUE_BY_KEY_SUCCESS:
    case types.UPDATE_PORTCO_SETTING_BY_KEY_SUCCESS: {
      return Object.assign({}, state, {
        portcoSettingsLoading: {
          ...state.portcoSettingsLoading,
          [payload.company_id]: {
            ...(state.portcoSettingsLoading &&
              state.portcoSettingsLoading[payload.company_id]),
            [payload.key]: false,
          },
        },
        portcoSettingsError: {
          ...state.portcoSettingsError,
          [payload.company_id]: {
            ...(state.portcoSettingsError &&
              state.portcoSettingsError[payload.company_id]),
            [payload.key]: null,
          },
        },
        portcoSettings: {
          ...state.portcoSettings,
          [payload.company_id]: {
            ...(state.portcoSettings &&
              state.portcoSettings[payload.company_id]),
            [payload.key]: payload.value,
          },
        },
      });
    }
    case types.LOAD_PORTCO_SETTING_VALUE_BY_KEY_FAILURE:
    case types.UPDATE_PORTCO_SETTING_BY_KEY_FAILURE: {
      return Object.assign({}, state, {
        portcoSettingsLoading: {
          ...state.portcoSettingsLoading,
          [payload.company_id]: {
            ...(state.portcoSettingsLoading &&
              state.portcoSettingsLoading[payload.company_id]),
            [payload.key]: false,
          },
        },
        portcoSettingsError: {
          ...state.portcoSettingsError,
          [payload.company_id]: {
            ...(state.portcoSettingsError &&
              state.portcoSettingsError[payload.company_id]),
            [payload.key]: payload.message,
          },
        },
      });
    }
    default:
      return state;
  }
};
